import { ClientPortfolioDataCommodityServiceEnum } from "web_myplann/Infrastructure/Api/Api";

const CONSUMPTION_COMMODITY_SERVICES: readonly ClientPortfolioDataCommodityServiceEnum[] =
	[
		ClientPortfolioDataCommodityServiceEnum.Electricity,
		ClientPortfolioDataCommodityServiceEnum.Gas,
		ClientPortfolioDataCommodityServiceEnum.Water,
	];

export const ServicesRequestVariant = {
	Metered: "Metered",
	FixedPrice: "FixedPrice",
	Untyped: "Untyped",
} as const;

export type ServicesRequestVariant =
	(typeof ServicesRequestVariant)[keyof typeof ServicesRequestVariant];

export const isConsumptionCommodityService = (
	value: ClientPortfolioDataCommodityServiceEnum | null | undefined,
): boolean => !!value && CONSUMPTION_COMMODITY_SERVICES.includes(value);

export const getServicesRequestVariant = (
	commodityService: ClientPortfolioDataCommodityServiceEnum | null | undefined,
): ServicesRequestVariant => {
	if (
		commodityService == null ||
		commodityService === ClientPortfolioDataCommodityServiceEnum.None
	) {
		return ServicesRequestVariant.Untyped;
	}

	return isConsumptionCommodityService(commodityService)
		? ServicesRequestVariant.Metered
		: ServicesRequestVariant.FixedPrice;
};
